export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
  image: string;
  features: string[];
}

export const categories: Category[] = [
  {
    id: 'training',
    name: '体育培训',
    slug: 'training',
    icon: 'ri-run-line',
    description: '专业教练团队，为不同年龄段和水平的学员提供篮球、足球、游泳、网球、羽毛球等多项运动的系统化培训课程，帮助您快速提升运动技能。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20sports%20training%20session%20with%20coach%20and%20athletes%20on%20indoor%20basketball%20court%2C%20warm%20lighting%2C%20dynamic%20action%2C%20clean%20minimal%20style%2C%20sporty%20atmosphere%2C%20warm%20orange%20and%20cream%20tones&width=800&height=600&seq=yunkai-cat-training&orientation=landscape',
    features: [
      '专业教练一对一指导',
      '科学化训练课程体系',
      '青少年体适能培训',
      '成人运动技能提升',
      '运动康复训练',
    ],
  },
  {
    id: 'events',
    name: '赛事组织',
    slug: 'events',
    icon: 'ri-trophy-line',
    description: '拥有丰富的赛事策划与执行经验，从社区联赛到大型锦标赛，提供赛事策划、场地布置、裁判安排、直播转播等全程服务。',
    image: 'https://readdy.ai/api/search-image?query=Sports%20event%20organization%20with%20athletes%20competing%20in%20arena%2C%20professional%20stadium%20lighting%2C%20crowd%20atmosphere%2C%20warm%20tones%2C%20clean%20composition%2C%20sporty%20professional%20photography%20style&width=800&height=600&seq=yunkai-cat-events&orientation=landscape',
    features: [
      '专业赛事策划方案',
      '全程赛事执行管理',
      '裁判及工作人员调度',
      '赛事直播与媒体报道',
      '赞助商对接服务',
    ],
  },
  {
    id: 'equipment',
    name: '运动装备',
    slug: 'equipment',
    icon: 'ri-basketball-line',
    description: '精选国内外优质运动品牌，涵盖篮球、足球、跑步、健身、游泳等各类运动装备，提供专业选购建议和团体定制服务。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20sports%20equipment%20and%20gear%20displayed%20on%20minimal%20white%20shelves%2C%20basketball%20and%20soccer%20items%2C%20clean%20product%20photography%2C%20warm%20cream%20background%2C%20modern%20retail%20aesthetic&width=800&height=600&seq=yunkai-cat-equipment&orientation=landscape',
    features: [
      '正品品牌运动装备',
      '专业装备选购指导',
      '企业团体定制服务',
      '装备维护保养建议',
      '新品首发优惠活动',
    ],
  },
  {
    id: 'venues',
    name: '场馆管理',
    slug: 'venues',
    icon: 'ri-building-line',
    description: '提供智能化场馆管理解决方案，包括场地预约系统、会员管理、设备维护、运营数据分析等，助力场馆高效运营。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20sports%20facility%20interior%20with%20clean%20architecture%2C%20multi-purpose%20indoor%20court%2C%20warm%20natural%20light%20from%20large%20windows%2C%20minimalist%20design%2C%20professional%20venue%20management%20scene&width=800&height=600&seq=yunkai-cat-venues&orientation=landscape',
    features: [
      '智能场地预约系统',
      '会员管理与营销工具',
      '设备维护提醒功能',
      '运营数据实时分析',
      '多渠道营收管理',
    ],
  },
];